import React, { useState, useEffect } from "react";
import { Card, CardContent, Box, Paper, Grid, Skeleton, CardHeader, Stack } from "@mui/material";
import { GridColDef, GridRenderCellParams, DataGrid, GridCheckIcon, GridCloseIcon } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import clientsService from "services/clientsService";
import Can from "common/Can";

const ClientList = () => {
  const [isAddClient, setIsAddClient] = useState(false);
  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    clientsService
      .getClients()
      .then((results) => {
        setClients(results);
      })
      .finally(() => setIsLoading(false));
  }, []);

  const LoadingSkeleton = () => (
    <Box
      sx={{
        height: "fit-content",
        padding: "0px",
        margin: "0px",
        overflow: "hidden",
      }}
    >
      {[...Array(10)].map((_, index) => (
        <Skeleton key={index} variant="rectangular" width="98%" sx={{ my: 3, mx: 1, overflow: "hidden" }} />
      ))}
    </Box>
  );

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "Id",
      flex: 1,
      renderCell: (params: GridRenderCellParams<any, number>) => (
        <Can perform={'EditClients'} yes={()=>(
                      <Link to={{ pathname: `/clients/${params.row.id}` }}>{params.value}</Link>
                      )} no={()=>( params.value)}/>
      ),
    },
    { field: "name", headerName: "Name", flex: 1},
    { field: "phoneNumber", headerName: "Phone", flex:1 },
    { field: "maxMiles", headerName: "Max Miles", width: 90},

    { field: "isBarge", headerName: "Is Barge", align: "center",
          renderCell: (params: GridRenderCellParams<any, boolean>) => params.value ? <GridCheckIcon style={{fill: "green"}}/>: <GridCloseIcon style={{fill: "red", textAlign:"center"}}/>},

    { field: "isShortline", headerName: "Is Short Line", align: "center",
          renderCell: (params: GridRenderCellParams<any, boolean>) => params.value ? <GridCheckIcon style={{fill: "green"}}/>: <GridCloseIcon style={{fill: "red", textAlign:"center"}}/>},

    { field: "isActive", headerName: "Active", align: "center",
          renderCell: (params: GridRenderCellParams<any, boolean>) => params.value ? <GridCheckIcon style={{fill: "green"}}/>: <GridCloseIcon style={{fill: "red", textAlign:"center"}}/>},
  ];

  return (
    <Card sx={{ mt: 2 }}>
      <CardHeader title="Clients"></CardHeader>
      <CardContent>
        <Grid container spacing={1} sx={{ fontSize: 11 }}>
          <Grid item xs={12}>
            <Box sx={{ mt: 2, overflow: "hidden" }}>
              <Paper sx={{ width: "99%", height: "auto", overflow: "hidden" }}>
                <DataGrid
                  sx={{ overflow: "hidden", height: isLoading ? "100vh" : "auto", fontSize: ".85rem" }}
                  autoHeight={isLoading ? false : true}
                  rows={clients || []}
                  columns={columns}
                  disableColumnMenu
                  slots={{
                    loadingOverlay: LoadingSkeleton,
                    noRowsOverlay: () => (
                      <Stack height="100%" alignItems="center" justifyContent="center">
                        No Clients
                      </Stack>
                    ),
                  }}
                  loading={isLoading}
                  density="compact"
                  getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? "Mui-even" : "Mui-odd")}
                />
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
export default ClientList;
